module.exports = __webpack_public_path__ + "img/2-2.92119ae5.png";